import { useEffect, useState } from "react";
import { Tooltip } from "antd";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";

// import mui icons
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

//import assets
import forwardPng from "../../assets/forward.png";

// import helper
import ConsumerFilterOrder from "utils/ConsumerFilterOrder";

// common components
import MissingFiltersTooltip from "../common/MissingFiltersTooltip";
import MissingFiltersDialog from "../common/MissingFiltersDialog";

//utils
import { checkFilterSelection, filterAcrossProducts } from "utils/consumerFilterUtils";
import { getMacroCategoryOrder } from "utils/GetConsumerFilterOrder";

//redux
import { useSelector, useDispatch } from "react-redux";
import { loadCurrentSelectedFiltersForCorrelationState, loadCurrentSelectedAllFiltersForCorrelationState, loadMissingFiltersForCorrelationState, loadWeightToggleForCorrelationState, loadDisableWeightToggleForCorrelationState } from "store/features/correlationSlice";

function CorrelationConsumerFilter({ product = {}, productsSecondaryData = [], handleFilterSubmit = () => { }, type = null }) {
    const dispatch = useDispatch();
    const consumerFilterStoreData = useSelector((state) => state.consumerFilterStore.filters);
    const missingFiltersStoreData = useSelector((state) => state.correlationStore.missingFiltersForCorrelation);
    const isFilterAcrossProductsForCorrelationStoreData = useSelector((state) => state.correlationStore.isFilterAcrossProductsForCorrelation);
    const dataMappingStoreData = useSelector((state) => state.dataMappingStore.displayLabelTranslation);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const [missingFiltersDialogOpen, setMissingFiltersDialogOpen] = useState(false);

    const [consumerFilter, setConsumerFilter] = useState(consumerFilterStoreData);

    const [tempMissingFilters, setTempMissingFilters] = useState({});

    const cfStoreData = JSON.parse(JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation)));
    const cfAllStoreData = JSON.parse(JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedAllFiltersForCorrelation)));
    const selectedStudies = useSelector((state) => state.studyDataStore.selectedStudies);

    const [currentFilterStoreData, setCurrentFilterStoreData] = useState(JSON.parse(JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation))) || {});
    const [currentFilterAllStoreData, setCurrentFilterAllStoreData] = useState(JSON.parse(JSON.stringify(useSelector((state) => state.correlationStore.currentSelectedAllFiltersForCorrelation))) || {});

    const [open, setOpen] = useState(false);

    const [backendVariableLabel, setBackendVariableLabel] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("");

    const [selectedFilterBackendVariables, setSelectedFilterBackendVariables] = useState([]);
    const [groupedVariables, setGroupedVariables] = useState([]);
    const [macroCategories, setMacroCategories] = useState([]);
    const [selectedMacroCategory, setSelectedMacroCategory] = useState("");
    const [visibleGroupedVariables, setVisibleGroupedVariables] = useState([]);

    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const macroOrder = getMacroCategoryOrder(productCategoryData?.label?.toLowerCase());

    let productCode = product.title
        .split(" ")
        .filter((ele) => ele !== "")
        .join("_");
    productCode = `${productCode}__${product.coreDataId}`;

    let customOrder = [];
    if (isSkinCare) {
        customOrder = [...ConsumerFilterOrder.correlationConsumerFiltersForSkinCare];
    } else if (isOralCare) {
        customOrder = [...ConsumerFilterOrder.correlationConsumerFiltersForOralCare];
    } else if (isSkinCleansing) {
        customOrder = [...ConsumerFilterOrder.correlationConsumerFiltersForSkinCleansing];
    } else if (isUnileverFragranceHouse) {
        customOrder = [...ConsumerFilterOrder.correlationConsumerFiltersForUFH];
    } else {
        customOrder = [...ConsumerFilterOrder.correlationConsumerFilters];
    }

    const customOrderSub = [...ConsumerFilterOrder.customOrderSub];
    const alphabeticOrderFilters = [...ConsumerFilterOrder.alphabeticOrderFilters];

    const handleMissingFiltersDialogOpen = () => {
        setMissingFiltersDialogOpen(!missingFiltersDialogOpen);
    };

    const getHairCareCustomOrder = (macroCategory) => {
        if (macroCategory === "Consumer Demographics") {
            return ConsumerFilterOrder.ConsumerDemographicsHairCare;
        }
        if (macroCategory === "Study Information") {
            return ConsumerFilterOrder.StudyInformationHairCare;
        }
        if (macroCategory === "Brand recognition") {
            return ConsumerFilterOrder.BrandRecognitionHairCare;
        }
        return [];
    };
    const sortWithPriority = (list, macroCategory) => {
        const priorityOrder = getHairCareCustomOrder(macroCategory);
        return list.slice().sort((a, b) => {
            const indexA = priorityOrder.indexOf(a);
            const indexB = priorityOrder.indexOf(b);
            if (indexA === -1 && indexB === -1) {
                return a.localeCompare(b);
            }
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });
    };

    useEffect(() => {
        if (type === "correlation") {
            const __consumerFilter = consumerFilter.map((datum) => {
                const productConsumerFilter = datum.consumer_filters;
                const _correlationConsumerFilters = isSkinCare ? ConsumerFilterOrder.correlationConsumerFiltersForSkinCare : (isOralCare ? ConsumerFilterOrder.correlationConsumerFiltersForOralCare :(isUnileverFragranceHouse ? ConsumerFilterOrder.correlationConsumerFiltersForUFH : ConsumerFilterOrder.correlationConsumerFilters));
                const backVarLabel = isHairCare
                    ? productConsumerFilter.backend_variable_display_label
                    : productConsumerFilter.backend_variable_display_label.filter((ele) => _correlationConsumerFilters.includes(ele.displayLabel));

                const backVarMap = {};
                backVarLabel.forEach((ele) => {
                    const obj = productConsumerFilter.backend_variable_mapping[ele.backendVariable];
                    backVarMap[ele.backendVariable] = obj;
                });

                const groupedVar = {};
                backVarLabel.forEach((ele) => {
                    const array = productConsumerFilter.grouped_variables[ele.displayLabel];
                    groupedVar[ele.displayLabel] = array;
                });

                const objects = {
                    product_code: datum.product_code,
                    core_data_id: datum.core_data_id,
                    consumer_filters: {
                        backend_variable_display_label: backVarLabel,
                        backend_variable_mapping: backVarMap,
                        grouped_variables: groupedVar,
                        macro_category_display_label_map: productConsumerFilter.macro_category_display_label_map ?? {},
                    },
                };
                return objects;
            });

            setConsumerFilter([...__consumerFilter]);
        }
    }, [type, ConsumerFilterOrder]);

    useEffect(() => {
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        const __displayLabel = tempData?.consumer_filters.backend_variable_display_label ? tempData?.consumer_filters.backend_variable_display_label : [];
        const __sortedData = __displayLabel?.slice()
            ? __displayLabel.slice().sort((a, b) => {
                const indexA = customOrder.indexOf(a.displayLabel);
                const indexB = customOrder.indexOf(b.displayLabel);
                if (isOralCare) {
                    if (a.displayLabel.toLowerCase() === "sample type") return -1;
                    if (b.displayLabel.toLowerCase() === "sample type") return 1;
                }
                if (indexA === -1 && indexB === -1) {
                    return a.displayLabel.localeCompare(b.displayLabel);
                }
                if (indexA === -1) {
                    return 1;
                }
                if (indexB === -1) {
                    return -1;
                }
                return indexA - indexB;
            })
            : [];

        setBackendVariableLabel(__sortedData);
        if (tempData?.consumer_filters.grouped_variables) {
            const groupedDisplayLabel = Object.keys(tempData?.consumer_filters.grouped_variables);
            const groupedDisplayLabelSortedDataArray = groupedDisplayLabel.slice().sort((a, b) => {
                const indexA = customOrder.indexOf(a);
                const indexB = customOrder.indexOf(b);
                if (isOralCare) {
                    if (a.toLowerCase() === "sample type") return -1;
                    if (b.toLowerCase() === "sample type") return 1;
                }
                if (indexA === -1 && indexB === -1) {
                    return a.localeCompare(b);
                }
                if (indexA === -1) {
                    return 1;
                }
                if (indexB === -1) {
                    return -1;
                }
                return indexA - indexB;
            });

            const sortedGroups = isHairCare ? sortWithPriority(groupedDisplayLabelSortedDataArray, selectedMacroCategory) : groupedDisplayLabelSortedDataArray;
            setGroupedVariables(sortedGroups);

            if (isHairCare) {
                const macroCategoriesFromApi = tempData?.consumer_filters?.macro_category_display_label_map ?? {};
                const macroCategoryKeys = Object.keys(macroCategoriesFromApi);
                if (macroCategoryKeys.length > 0) {
                    const sortedMacroKeys = macroCategoryKeys.slice().sort((a, b) => {
                        const indexA = macroOrder.indexOf(a);
                        const indexB = macroOrder.indexOf(b);
                        if (indexA === -1 && indexB === -1) return a.localeCompare(b);
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });
                    setMacroCategories(sortedMacroKeys);
                    const firstMacro = sortedMacroKeys[0];
                    setSelectedMacroCategory(firstMacro);
                    const firstMacroGroups = macroCategoriesFromApi[firstMacro] || [];
                    const visibleFiltered = groupedDisplayLabelSortedDataArray.filter((g) => firstMacroGroups.includes(g));
                    const sortedVisible = sortWithPriority(visibleFiltered, firstMacro);
                    setVisibleGroupedVariables(sortedVisible);
                    if (visibleFiltered.length > 0) {
                        setSelectedFilter(visibleFiltered[0]);
                        setSelectedFilterBackendVariables(groupedData[visibleFiltered[0]]);
                    }
                } else {
                    // Hair Care but macro_category_display_label_map absent — fallback to full list
                    setVisibleGroupedVariables(groupedDisplayLabelSortedDataArray);
                    setSelectedFilter(groupedDisplayLabelSortedDataArray[0]);
                    setSelectedFilterBackendVariables(groupedData[groupedDisplayLabelSortedDataArray[0]]);
                }
            } else {
                setSelectedFilter(groupedDisplayLabelSortedDataArray[0]);
                setSelectedFilterBackendVariables(groupedData[groupedDisplayLabelSortedDataArray[0]]);
            }
        }
    }, [consumerFilter, product, isOralCare]);

    useEffect(() => {
        if (Object.keys(currentFilterStoreData).length === 0) {
            const initialFiltersValue = {};
            productsSecondaryData.forEach((datum) => {
                let product = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                product = `${product}__${datum.coreDataId}`;
                const temp = {};
                let tempData = consumerFilter.find((ele) => ele.product_code == datum.title && ele.core_data_id == datum.coreDataId);
                tempData?.consumer_filters.backend_variable_display_label.forEach((element) => {
                    const _backendVariable = element.backendVariable;
                    if (currentFilterStoreData && currentFilterStoreData[product] && currentFilterStoreData[product].filters[_backendVariable]) {
                        temp[_backendVariable] = currentFilterStoreData[product].filters[_backendVariable];
                    } else {
                        const array = tempData.consumer_filters?.backend_variable_mapping[_backendVariable].map((datum) => {
                            return {
                                value: datum,
                                label: datum,
                                checked: false,
                            };
                        });
                        temp[_backendVariable] = [...array];
                    }
                });
                initialFiltersValue[product] = {
                    filters: { ...temp },
                    productCoreDataId: datum.coreDataId,
                };
                setCurrentFilterStoreData({ ...initialFiltersValue });
            });
            dispatch(loadCurrentSelectedFiltersForCorrelationState(initialFiltersValue));
        }

        if (Object.keys(currentFilterAllStoreData).length === 0) {
            const initialSelectAllChecked = {};
            productsSecondaryData.forEach((datum) => {
                let product = datum.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                product = `${product}__${datum.coreDataId}`;
                const temp = {};
                let tempData = consumerFilter.find((ele) => ele.product_code == datum.title && ele.core_data_id == datum.coreDataId) || {};
                Object.keys(tempData?.consumer_filters?.grouped_variables || {}).forEach((element) => {
                    const displayLabel = element;
                    temp[displayLabel] = currentFilterAllStoreData && currentFilterAllStoreData[product] && currentFilterAllStoreData[product].filters[displayLabel] ? currentFilterAllStoreData[product].filters[displayLabel] : false;
                });
                initialSelectAllChecked[product] = {
                    filters: { ...temp },
                    productCoreDataId: datum.coreDataId,
                };
                setCurrentFilterAllStoreData({ ...initialSelectAllChecked });
            });
            dispatch(loadCurrentSelectedAllFiltersForCorrelationState(initialSelectAllChecked));
        }
    }, []);

    const handleClick = () => {
        setOpen((prev) => !prev);
        setCurrentFilterStoreData(JSON.parse(JSON.stringify(cfStoreData)));
        setCurrentFilterAllStoreData(JSON.parse(JSON.stringify(cfAllStoreData)));
    };

    const handleClickAway = () => {
        // setOpen(false);
    };

    const openButtons = () => {
        return (
            <div
                style={{
                    fontSize: "0.75rem",
                    color: "#4d4d4d",
                    borderBottom: "2px solid #dee2e6",
                    margin: "0px 40px",
                }}
            >
                <span
                    onClick={handleClick}
                    style={{
                        cursor: "pointer",
                    }}
                >
                    {
                        <ManageAccountsIcon
                            fontSize="small"
                            className="color-blue"
                            // key="manage-accounts-icon"
                            // onClick={toggleDrawer("left", true)}
                            sx={{
                                margin: "0px 5px 0px 0px",
                            }}
                        />
                    }
                    <span
                        style={{
                            fontWeight: 600,
                        }}
                    >
                        Filters
                    </span>
                    {
                        <ArrowDropDownIcon
                            className="color-blue"
                            // key="arrow-drop-down-icon"
                            sx={{
                                margin: "0px 0px 0px 5px",
                            }}
                        />
                    }
                    {missingFiltersStoreData && missingFiltersStoreData?.[productCode] && missingFiltersStoreData?.[productCode]?.isMissing === "true" && (
                        <MissingFiltersTooltip
                            missingFilters={missingFiltersStoreData}
                            product={productCode}
                        />
                    )}
                </span>
            </div>
        );
    };

    const returnLabels = () => {
        const _checkedFilter = backendVariableLabel.map((element) => {
            const _label = element.backendVariable;
            const displayLabelName = element.displayLabel;
            let checkedValues = cfStoreData[productCode]?.filters[_label]?.filter((ele) => ele.checked === true);
            return {
                labelName: _label,
                displayLabelName: displayLabelName,
                checkedValues: checkedValues ? checkedValues : [],
            };
        });
        const checkedFilter = _checkedFilter?.filter((datum) => datum.checkedValues.length !== 0);

        return (
            <div
                style={{
                    fontSize: 11,
                    display: "inline-block",
                    // width: "100%",
                    textAlign: "left",
                    padding: 10,
                    zIndex: 0,
                }}
            >
                {checkedFilter.slice(0, 3).map((ele, i) => {
                    // const label = ele.labelName;
                    const displayLabel = ele.displayLabelName;
                    const values = ele.checkedValues.map((datum) => datum.label.replace(/ \|/g, ",").trim()).join(";");
                    return (
                        <div
                            key={i}
                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
                        >
                            <p>
                                <span className="my-0 text-bold-6">{`${displayLabel}:`}</span>
                                <span
                                    style={{
                                        color: "#4d4d4d",
                                    }}
                                >{`${values}`}</span>
                            </p>
                        </div>
                    );
                })}

                {checkedFilter.length > 3 && (
                    <Tooltip
                        placement="top"
                        color="white"
                        overlayClassName="fixed-height-tooltip"
                        // open={true}
                        title={checkedFilter.slice(3).map((ele, i) => {
                            const displayLabel = ele.displayLabelName;
                            const values = ele.checkedValues.map((datum) => datum.label.replace(/ \|/g, ",").trim()).join(";");

                            return (
                                <div
                                    key={i}
                                // style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
                                >
                                    <p>
                                        <span
                                            style={{ color: "#000", fontSize: "11px", fontWeight: "bold" }}
                                            className="my-0 text-bold-6"
                                        >
                                            {`${displayLabel}:`}
                                        </span>
                                        <span
                                            style={{
                                                color: "#4d4d4d",
                                                fontSize: "11px",
                                            }}
                                        >
                                            {`${values}`}
                                        </span>
                                    </p>
                                </div>
                            );
                        })}
                    >
                        <span style={{ color: "blue", fontWeight: "bold" }}>See More...</span>
                    </Tooltip>
                )}
            </div>
        );
    };

    const returnCheckBoxes = (label, i, backendVariable, productCode, displayLabel) => {
        let result = currentFilterStoreData[productCode]?.filters[backendVariable]?.filter((o) => o.value === label);
        return (
            <FormControlLabel
                key={i}
                sx={{
                    "& .MuiTypography-root": {
                        fontSize: 12,
                    },
                }}
                style={{
                    // borderBottom: "1px solid grey",
                    margin: "0px 0px 0px 0px",
                    padding: "3px 0px",
                    textAlign: "left",
                }}
                control={
                    <Checkbox
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fontSize: 18,
                            },
                        }}
                        color="secondary"
                        id={`${backendVariable}-${i}`}
                        checked={result && result.length > 0 ? result[0].checked : false}
                        onChange={() => handleOnChange(backendVariable, label, "individualCheck", productCode, displayLabel)}
                        value={label}
                    // name={`${identifier}-${i}`}
                    />
                }
                label={label.replace(/ \|/g, ",").trim()}
            />
        );
    };

    const returnSelectAllAndClear = (label, displayLabel, productCode) => {
        return (
            <div
                className="px-2"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "sticky",
                    borderBottom: "1px solid grey",
                    backgroundColor: "white",
                }}
            >
                <div>
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>
                            <FormControlLabel
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: 14,
                                    },
                                }}
                                control={
                                    <Checkbox
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 18,
                                            },
                                        }}
                                        color="secondary"
                                        // id={`${identifier}-${i}`}
                                        checked={currentFilterAllStoreData[productCode]?.filters[displayLabel]}
                                        onChange={() => handleAllChecked(displayLabel, "allChecked", productCode)}
                                    // value={value}
                                    // name={`${identifier}-${label}`}
                                    />
                                }
                                label={label}
                            />
                        </FormGroup>
                    </FormControl>
                </div>
                <div>
                    <Button
                        size="small"
                        className="custom-btn-outlined color-blue"
                        variant="outlined"
                        style={{
                            padding: "0px 7px",
                            textTransform: "unset",
                            top: 4,
                        }}
                        onClick={() => handleAllChecked(displayLabel, "clearAll", productCode)}
                    // startIcon={<ScienceIcon />}
                    >
                        Clear All
                    </Button>
                </div>
            </div>
        );
    };

    const sortSubFilters = (displayLabel, backendVariable) => {
        const tempData = consumerFilter.find((ele) => ele.product_code == product.title && ele.core_data_id == product.coreDataId);
        const selectedFilterMappingObject = JSON.parse(JSON.stringify(tempData.consumer_filters.backend_variable_mapping?.[backendVariable]));

        // Sort selectedFilterMappingObject with extra elements placed at the start when displayLabel is not in  alphabeticOrderFilters list else alphabetical sort(default sorted from backend)
        if (!alphabeticOrderFilters.includes(displayLabel)) {
            selectedFilterMappingObject.sort((a, b) => {
                const indexA = customOrderSub.indexOf(a);
                const indexB = customOrderSub.indexOf(b);

                // If an element is not found in customOrderSub, move it to the start (by returning -1)
                if (indexA === -1 && indexB === -1) return 0; // both are extra, maintain their order
                if (indexA === -1) return -1; // a is extra, move it to the start
                if (indexB === -1) return 1; // b is extra, move it to the start

                // Otherwise, sort based on the order in array1
                return indexA - indexB;
            });
        }
        return selectedFilterMappingObject;
    };

    const checkFilterStatus = (coreDataId) => {
        let _filters = currentFilterStoreData;
        let sFlag = false;
        Object.entries(_filters).forEach((datum) => {
            if (datum[1].productCoreDataId === coreDataId && !sFlag) {
                Object.entries(datum[1].filters).forEach((ele) => {
                    ele[1].forEach((sub) => {
                        if (sub.checked) {
                            sFlag = true;
                        }
                    });
                });
            }
        });
        return sFlag;
    };

    const handleMacroCategoryClick = (macroCategory) => {
         setSelectedMacroCategory(macroCategory); 
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        const macroCatGroups = tempData?.consumer_filters?.macro_category_display_label_map?.[macroCategory] || [];
        const filtered = groupedVariables.filter((g) => macroCatGroups.includes(g));
        const sortedFiltered = sortWithPriority(filtered, macroCategory);
        setVisibleGroupedVariables(sortedFiltered);
        if (filtered.length > 0) {
            setSelectedFilter(sortedFiltered[0]);
            setSelectedFilterBackendVariables(groupedData[sortedFiltered[0]]);
        }
    };

    const handleFilterLabelClick = (displayLabel) => {
        const tempData = consumerFilter.find((ele) => ele.product_code === product.title && ele.core_data_id.toString() === product.coreDataId.toString());
        const groupedData = tempData?.consumer_filters.grouped_variables;
        setSelectedFilter(displayLabel);
        setSelectedFilterBackendVariables(groupedData[displayLabel]);
    };

    const handleOnChange = (backendVariable, label, eventName, productCode, displayLabel) => {
        let datum = { ...currentFilterStoreData[productCode].filters };

        // * if the value of the passed position parameter matches with the current index, then we reverse its value. Then, if the value is true it will be converted to false using !item and if the value is false, then it will be converted to true.
        const updatedCheckedState = currentFilterStoreData[productCode]?.filters[backendVariable]?.map((item) => {
            return item.value === label ? { ...item, checked: !item.checked } : { ...item }; // Create new objects for each item
        });

        datum[backendVariable] = [...updatedCheckedState];
        let _filter = JSON.parse(JSON.stringify(currentFilterStoreData));
        _filter[productCode].filters = { ...datum };

        setCurrentFilterStoreData({ ..._filter });

        // logic to handle select all if every filters are checked one by one
        // looping over updatedCheckedState to check if every filter is selected or not to handle select all
        if (!updatedCheckedState.some((ele) => ele.checked === false)) {
            if (currentFilterAllStoreData[productCode]) {
                currentFilterAllStoreData[productCode].filters[displayLabel] = true;
            }
        } else {
            if (currentFilterAllStoreData[productCode]) {
                currentFilterAllStoreData[productCode].filters[displayLabel] = false;
            }
        }
    };

    const handleAllChecked = (displayLabel, eventName, productCode) => {
        let filterSelectionStatus = {};
        let coreDataId = currentFilterStoreData[productCode].productCoreDataId;
        let obj = { ...currentFilterAllStoreData[productCode].filters };

        if (eventName === "allChecked") {
            obj[displayLabel] = !obj[displayLabel];

            //handle every filters checkbox
            let datum = { ...currentFilterStoreData[productCode].filters };
            let _filter = { ...currentFilterStoreData };
            selectedFilterBackendVariables.forEach((backendVariable) => {
                const temp = currentFilterStoreData[productCode].filters[backendVariable].map((datum) => {
                    return {
                        value: datum.value,
                        label: datum.label,
                        checked: obj[displayLabel],
                    };
                });
                datum[backendVariable] = [...temp];
                _filter[productCode].filters = { ...datum };
            });

            setCurrentFilterStoreData({ ..._filter });

            // updating studyPageFilters global data

            let _allFilter = { ...currentFilterAllStoreData };
            _allFilter[productCode].filters = { ...obj };
            setCurrentFilterAllStoreData(_allFilter);
        } else if (eventName === "clearAll") {
            obj[displayLabel] = false;

            // clear every filters checkbox
            let datum = currentFilterStoreData[productCode].filters;
            let _allFilter = { ...currentFilterAllStoreData };
            let _filter = { ...currentFilterStoreData };
            selectedFilterBackendVariables.forEach((backendVariable) => {
                const temp = currentFilterStoreData[productCode].filters[backendVariable].map((datum) => {
                    return {
                        value: datum.value,
                        label: datum.label,
                        checked: false,
                    };
                });
                datum[backendVariable] = [...temp];
                _filter[productCode].filters = datum;
                _allFilter[productCode].filters = { ...obj };
            });

            setCurrentFilterStoreData({ ..._filter });
            setCurrentFilterAllStoreData({ ..._allFilter });

            // updating studyPageFilters global data
            filterSelectionStatus.filterSelected = checkFilterStatus(coreDataId);
            filterSelectionStatus.coreDataId = coreDataId;
        }
    };

    const applyFiltersToAllProducts = () => {
        const selectedProductFilters = currentFilterStoreData[productCode].filters;
        const checkedFilters = {};

        Object.keys(selectedProductFilters).forEach((filterCategory) => {
            const filterOptions = selectedProductFilters[filterCategory];
            const checkedOptions = filterOptions.filter((option) => option.checked === true);

            if (checkedOptions.length > 0) {
                checkedFilters[filterCategory] = checkedOptions;
            }
        });

        const checkedData = { ...currentFilterStoreData };
        Object.keys(currentFilterStoreData).map((item) => {
            const updatedFilters = { ...currentFilterStoreData[item].filters };
            for (const key of Object.keys(updatedFilters)) {
                if (Object.keys(checkedFilters).includes(key)) {
                    const appliedFilters = checkedFilters[key];
                    const unAppliedFilters = updatedFilters[key];
                    const newArr = unAppliedFilters.map((obj2) => {
                        const matchingObj = appliedFilters.find((obj1) => obj1.value === obj2.value);
                        if (matchingObj) {
                            return { ...obj2, checked: true };
                        } else {
                            return { ...obj2, checked: false };
                        }
                    });
                    updatedFilters[key] = newArr;
                } else {
                    const unAppliedFilters = updatedFilters[key];
                    const newArr = unAppliedFilters.map((obj2) => {
                        return { ...obj2, checked: false };
                    });
                    updatedFilters[key] = newArr;
                }
            }
            const finalFilters = {
                ...currentFilterStoreData[item],
                filters: updatedFilters,
            };
            checkedData[item] = finalFilters;

            Object.keys(updatedFilters).map((eachFilter) => {
                const displayLabel = dataMappingStoreData[eachFilter];
                if (!updatedFilters[eachFilter].some((ele) => ele.checked === false)) {
                    if (currentFilterAllStoreData[item]) {
                        currentFilterAllStoreData[item].filters[displayLabel] = true;
                    }
                } else {
                    if (currentFilterAllStoreData[item]) {
                        currentFilterAllStoreData[item].filters[displayLabel] = false;
                    }
                }
            });
        });

        setCurrentFilterStoreData(checkedData);
        setCurrentFilterAllStoreData(currentFilterAllStoreData);
        dispatch(loadCurrentSelectedAllFiltersForCorrelationState(currentFilterAllStoreData));
        dispatch(loadCurrentSelectedFiltersForCorrelationState(checkedData));
        if (checkFilterSelection(checkedData)) {
            dispatch(loadWeightToggleForCorrelationState(false));
            dispatch(loadDisableWeightToggleForCorrelationState(true));
            handleFilterSubmit(null, checkedData, {}, false);
        } else {
            const arr = [];
            selectedStudies.forEach((item) => {
                arr.push(item?.["weighted"]);
            });
            const flag = arr.some((ele) => ele === true);

            if (flag) {
                dispatch(loadWeightToggleForCorrelationState(flag));
                dispatch(loadDisableWeightToggleForCorrelationState(!flag));
                handleFilterSubmit(null, checkedData, {}, flag);
            }
        }
        setOpen(false);
    };

    const handleSubmit = async () => {
        if (isFilterAcrossProductsForCorrelationStoreData) {
            const missingFilters = filterAcrossProducts(currentFilterStoreData, productCode);
            setTempMissingFilters(missingFilters);

            if (Object.values(missingFilters).some((datum) => datum.isMissing === "true")) {
                handleMissingFiltersDialogOpen(!missingFiltersDialogOpen);
            } else {
                dispatch(loadMissingFiltersForCorrelationState(missingFilters));
                applyFiltersToAllProducts();
            }
        } else {
            await dispatch(loadCurrentSelectedFiltersForCorrelationState(currentFilterStoreData));
            await dispatch(loadCurrentSelectedAllFiltersForCorrelationState(currentFilterAllStoreData));
            if (checkFilterSelection(currentFilterStoreData)) {
                await dispatch(loadWeightToggleForCorrelationState(false));
                await dispatch(loadDisableWeightToggleForCorrelationState(true));
                handleFilterSubmit(null, currentFilterStoreData, missingFiltersStoreData, false);
            } else {
                const arr = [];
                selectedStudies.forEach((item) => {
                    arr.push(item?.["weighted"]);
                });
                const flag = arr.some((ele) => ele === true);

                if (flag) {
                    await dispatch(loadWeightToggleForCorrelationState(flag));
                    await dispatch(loadDisableWeightToggleForCorrelationState(!flag));
                    handleFilterSubmit(null, currentFilterStoreData, missingFiltersStoreData, flag);
                }
            }
            setOpen(false);
        }
    };

    return (
        <>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={handleClickAway}
            >
                <Box sx={{ position: "relative" }}>
                    {openButtons()}
                    {returnLabels()}
                    {open && (
                        <Box
                            role="presentation"
                            sx={{
                                position: "absolute",
                                top: 28,
                                right: 0,
                                left: 0,
                                border: "1px solid #dee2e6",
                                bgcolor: "background.paper",
                                width: isHairCare ? "600px" : "400px",
                                zIndex: 1,
                            }}
                        >
                            <div
                                className="filter-box "
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                }}
                            >
                                {isHairCare && macroCategories.length > 0 && (
                                    <div
                                        className="py-3"
                                        style={{
                                            width: "33%",
                                            minHeight: "475px",
                                            height: "475px",
                                            backgroundColor: "#9c27b0",
                                            textAlign: "left",
                                            overflowY: "scroll",
                                        }}
                                    >
                                        {macroCategories.map((macro, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    margin: "2px 0",
                                                    cursor: "pointer",
                                                    padding: "10px 20px",
                                                    width: "100%",
                                                }}
                                                className={selectedMacroCategory === macro ? "remove-opacity" : "enable-filter"}
                                                onClick={() => handleMacroCategoryClick(macro)}
                                            >
                                                <span style={{ fontSize: "0.75rem", color: "#fff", fontWeight: 600 }}>{macro}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div
                                    className="py-3"
                                    style={{
                                        width: isHairCare ? "33%" : "50%",
                                        minHeight: "475px",
                                        height: "475px",
                                        background: isHairCare ? "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)" : "#9c27b0",
                                        textAlign: "left",
                                        overflowY: "scroll",
                                        borderRight: isHairCare ? "1px solid #dee2e6" : "none",
                                    }}
                                >
                                    {(isHairCare ? visibleGroupedVariables : groupedVariables)?.map((ele, i) => {
                                        return (
                                            <div
                                                key={i}
                                                style={{
                                                    margin: "2px 0",
                                                    cursor: "pointer",
                                                    padding: "10px 20px",
                                                    width: "100%",
                                                }}
                                                className={selectedFilter === ele ? "remove-opacity" : "enable-filter"}
                                                onClick={() => handleFilterLabelClick(ele)}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        color: isHairCare ? "#4d4d4d" : "#fff",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {ele}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div
                                    className="filter-value-box pt-2 pb-0 px-0"
                                    style={{
                                        width: isHairCare ? "34%" : "50%",
                                        minHeight: "475px",
                                        height: "475px",
                                        background: isHairCare ? "#f8f9fa" : "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)",
                                    }}
                                >
                                    <>
                                        {returnSelectAllAndClear("Select All", selectedFilter, productCode)}
                                        {selectedFilterBackendVariables && (
                                            <div
                                                className="px-3"
                                                style={{
                                                    overflowY: "scroll",
                                                    height: "386px",
                                                }}
                                            >
                                                <FormGroup>
                                                    {selectedFilterBackendVariables &&
                                                        selectedFilterBackendVariables.map((ele) => {
                                                            const sortedData = sortSubFilters(selectedFilter, ele);
                                                            return sortedData.map((label, i) => {
                                                                return returnCheckBoxes(label, i, ele, productCode, selectedFilter);
                                                            });
                                                        })}
                                                </FormGroup>
                                            </div>
                                        )}
                                    </>
                                    <div>
                                        <div
                                            className="px-2 py-1"
                                            style={{
                                                position: "absolute",
                                                right: 60,
                                                bottom: 0,
                                                cursor: "pointer",
                                                width: 45,
                                                height: 35,
                                                // overflow: "hidden",
                                            }}
                                            onClick={handleSubmit}
                                        >
                                            <img
                                                style={{
                                                    width: 30,
                                                    height: 25,
                                                    color: "white",

                                                    filter: "brightness(0) invert(1)",
                                                }}
                                                src={forwardPng}
                                                alt={"forward"}
                                            />
                                        </div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1440 320"
                                        >
                                            <path
                                                fill="#9c27b0"
                                                fillOpacity="1"
                                                d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,101.3C840,64,960,64,1080,106.7C1200,149,1320,235,1380,277.3L1440,320L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
                                            ></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </Box>
                    )}
                </Box>
            </ClickAwayListener>
            {missingFiltersDialogOpen && (
                <MissingFiltersDialog
                    productCode={productCode}
                    currentFilterStoreData={currentFilterStoreData}
                    setCurrentFilterStoreData={setCurrentFilterStoreData}
                    handleFilterSubmit={handleFilterSubmit}
                    missingFiltersDialogOpen={missingFiltersDialogOpen}
                    handleMissingFiltersDialogOpen={handleMissingFiltersDialogOpen}
                    setOpen={setOpen}
                    setCurrentFilterAllStoreData={setCurrentFilterAllStoreData}
                    missingFilters={tempMissingFilters}
                    // allAnalysisData={allAnalysisData}
                    type="correlation"
                />
            )}
        </>
    );
}

// Typechecking props for the OverallKpi
CorrelationConsumerFilter.propTypes = {
    product: PropTypes.object,
    productsSecondaryData: PropTypes.array,
    handleFilterSubmit: PropTypes.func,
    type: PropTypes.string,
};

export default CorrelationConsumerFilter;
